import { gql, useMutation } from '@apollo/client';
import { GET_QUESTIONNAIRES_BY_ID } from './get-employee-questionnaire-by-id.hook';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

export const PARTIAL_EMPLOYEE_QUESTIONNAIRES_UPDATE = gql`
  mutation partialEmployeeQuestionnaireUpdate($payload: PartialEmployeeQuestionnaireUpdateInput!) {
    partialEmployeeQuestionnaireUpdate(payload: $payload) {
      _id
    }
  }
`;

export const usePartialEmployeeQuestionnaireUpdate = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const [partialEmployeeQuestionnaireUpdate] = useMutation(PARTIAL_EMPLOYEE_QUESTIONNAIRES_UPDATE, {
    onCompleted: (data) => {
      if (onSuccess && data) {
        onSuccess();
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any; errors?: any }) => {
      const [error] = graphQLErrors || [];
      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: 'Error',
        description: error?.message || error?.description,
      });
    },
    refetchQueries: [GET_QUESTIONNAIRES_BY_ID],
  });

  return partialEmployeeQuestionnaireUpdate;
};
